import React, { useEffect, useState } from "react";
import "../style/page/patientview.scss"
import { useSelector, useDispatch } from "react-redux";
import { editdoctoruser, pvtabs } from "../redux/reducer/counterslice";
import axios from "axios";
import { patientlist, spacilitylist } from "../../text/apidata";
import { useNavigate } from "react-router-dom";
import { editdoctoruserid, basetimeedit, sidebar } from "../redux/reducer/counterslice";
import patientsrc from "../../assets/images/patient.png"
import noimage from "../../assets/images/noimage.png"
import SubAccount from "./tabs/psubaccount";
export default function PatientView(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [gender, setGender] = React.useState("");
  const [type, settype] = React.useState("");
  const [mr, setmr] = useState("");
  const [doctorspacilityselected, setdoctorspacilityselected] = useState([]);
  const [sidebarvalue, setsidebarvalue] = useState("Doctor View");
  const [selected, setSelected] = useState([]);
  const [language, setlanguage] = useState([]);
  const editdoctoruserselect = useSelector(
    (state) => state.counter.editdoctoruser
  );
  const minisbstate = useSelector((state) => state.counter.minisidebar);
  console.log(doctorspacilityselected)
  const [nationality, setnationality] = useState("");
  const [creatfirstname, setCreatefirstname] = useState("");
  const [branch, setbranch] = useState("");
  const [creatlastname, setCreatelastname] = useState("");
  const [creatphoneno, setCreatephoneno] = useState("");
  const [dob, setdob] = useState("");
  const [creatgender, setCreategender] = useState("");
  const [getemail, setgetemail] = useState();
  const editpatientid = useSelector((state) => state.counter.patientid);
  const [url, setUrl] = useState();
  const editadminuserform = useNavigate();
  const [checked, setChecked] = React.useState(true);
  const [UHID, setuhid] = useState("");
  const dispatch = useDispatch();
  const [tab, settab] = useState("About")
  const subtabs = useSelector((state) => state.counter.pvtabs);
  const tabsstate = useDispatch();
  const [popup, setpopup] = useState(false);
  const [id, setid] = useState();
  const [ismaster, setismaster] = useState()
  const [address, setAddress] = useState({})


  console.log(tab)
  useEffect(() => {
    // console.log(editdoctorid)
    props.loaderchange("true");
    axios({
      method: "get",
      url: patientlist + editpatientid + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        console.log(res.data.data);
        if (res.status == 200) {
          let spacilityArray = [];
          console.log(res.data.data.type);
          setGender(res.data.data.gender);
          settype(res.data.data.type);
          setgetemail(res.data.data.email != null && res.data.data.email != "" ? res.data.data.email : "--");
          setid(res.data.data.id);
          setuhid(res.data.data.p_uhid != null && res.data.data.p_uhid != "" ? res.data.data.p_uhid : "--")
          setCreatefirstname(res.data.data.first_name);
          setbranch(res.data.data.branch_display);
          setCreatelastname(res.data.data.last_name);
          setCreatephoneno(res.data.data.phonenumber);
          setdob(res.data.data.birthdate != null ? res.data.data.birthdate : "--");
          setCreategender(res.data.data.gender);
          setSelected(res.data.data.doctor_qualifications);
          setlanguage(res.data.data.languages_known);
          setChecked(res.data.data.is_active);
          settype(res.data.data.type);
          setmr(res.data.data.titles != null ? res.data.data.titles : "");
          setUrl(res.data.data.profile_pic);
          setnationality(res.data.data.nationality)
          setismaster(res.data.data.is_master)
          setAddress({ address: res.data.data.address, city: res.data.data.city, zip: res.data.data.zipcode, aadhaar: res.res.data.aadhaar_number })
          props.loaderchange("false");
        }
      })
      .catch((error) => {
        // console.log(creatdoctorinfo, editdoctorid);
        console.log(error);
        props.loaderchange("false");
      });
  }, [editdoctoruserselect, minisbstate]);

  const onclick = () => {
    editadminuserform("/PatientForm");
    dispatch(editdoctoruser("activedoctoredit"));
    dispatch(editdoctoruserid(editpatientid));

  }

  const tabclick = (e) => {
    console.log(e.target.innerText)
    settab(e.target.innerText)
    tabsstate(pvtabs(e.target.innerText));

  }
  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };
  const deleteappoinment = (e) => {
    setpopup(true);
  };

  const confirmcancel = () => {
    axios({
      method: "delete",
      url: patientlist + id + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        console.log(res.data);
        setpopup(false);
        // window.location.reload()
        editadminuserform("/Patient");
        props.loaderchange("false");
        props.popupalert("true");
        props.popuptext("Patient Deleted Successfully");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        // console.log(dtpageindex)
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      });
  }

  return (
    <>
      <div className={sideactive ? "patient-view-sa" : "patient-view"}>
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">Profile</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/" style={{ textDecoration: "none", color: "black" }}
                        onClick={(e) => {
                          dispatch(sidebar("DashBoard"))
                        }}
                      >Dashboard</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="/Patient" style={{ textDecoration: "none", color: "black" }}>Patient</a>
                    </li>
                    <li className="breadcrumb-item active">Profile</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-md-12">
                <div className="profile-header">
                  <div className="row align-items-center">
                    <div className="col-auto profile-image">
                      <a >
                        <img className="user" alt="User Image" src={url ? url : noimage} />
                        {/* <img src={star} className="star"></img> */}
                      </a>
                    </div>
                    <div className="col ml-md-n2 profile-user-info" style={{ padding: "0px 35px" }}>
                      <h3 className="user-name mb-0">
                        {mr + " " + creatfirstname + creatlastname}
                      </h3>
                      <div className="row" style={{ height: 30, padding: "0px 10px" }}>
                        <p className="col-md-1 mb-0 p-0" style={{ width: 55 }} >
                          Email:
                        </p>
                        <span className="col-sm-4 mb-0 pl-0 text-left">{getemail}</span>
                      </div>
                      <div className="row" style={{ height: 30, padding: "0px 10px" }} >
                        <span className="col-sm-1 p-0" style={{ width: 55 }} >
                          UHID:
                        </span>
                        <p className="col-sm-3 pl-0 text-left">
                          {UHID}
                        </p>
                      </div>
                      <button className="master" >{ismaster == true ? "MasterAccount" : "SubAccount"}</button>
                    </div>
                    <div className="col-auto profile-btn">
                      <a
                        className="btn btn-primary editview"
                        onClick={(e) => onclick(e)}
                      >
                        Edit
                      </a>
                      <a
                        className="btn btn-danger ml-2" style={{ color: "#fff" }}
                        onClick={(e) => deleteappoinment(e)}
                      >
                        Delete
                      </a>
                    </div>
                  </div>
                </div>
                <div className="profile-menu">
                  <ul
                    className="nav nav-tabs"
                    role="tablist"
                    style={{
                      backgroundColor: "white",
                      // boxShadow:
                      //   "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
                      height: "50px",
                      // borderRadius: 10,
                      // border:"none"
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    {" "}
                    <button
                      // class="nav-link active about"
                      className={`nav-link${subtabs == "About" ? " active" : ""
                        } about`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      About
                    </button>
                    {/* <button
                      // class="nav-link basetime"
                      className={`nav-link${subtabs == "Address" ? " active" : ""
                        } basetime`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="false"
                      href="#password_tab"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      Address
                    </button>
                    <button
                      className={`nav-link${subtabs == "Appoinment" ? " active" : ""
                        } timeslot`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="false"
                      href="#password_tab"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      Appoinment
                    </button> */}
                    <button
                      className={`nav-link${subtabs == "Sub-Account" ? " active" : ""
                        } appoinmenttab`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="false"
                      href="#password_tab"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      {ismaster == false ? "MasterAccount" : "SubAccount"}
                    </button>
                    {/* <button
                      className={`nav-link${subtabs == "Not Available" ? " active" : ""
                        } notavailabletab`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="false"
                      href="#password_tab"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      Not Available
                    </button> */}
                  </ul>
                </div>
                {subtabs == "About" ? (
                  <>
                    <div className="tab-content profile-tab-cont">
                      <div
                        className="tab-pane fade show active"
                        id="per_details_tab"
                      >
                        {/* Personal Details */}
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="card">
                              <div className="card-body row">
                                <div className="col-md-6">
                                  <h5 className="card-title d-flex justify-content-between">
                                    <span>Personal Details</span>
                                    {/* <a
                                    className="edit-link"
                                    data-toggle="modal"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => onclick(e)}
                                  >
                                    <i class="bi bi-pencil-fill"></i> Edit
                                  </a> */}
                                  </h5>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                                      Name :
                                    </p>
                                    <p className="col-sm-9">
                                      {mr + creatfirstname + creatlastname}
                                    </p>
                                  </div>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                                      UHID :
                                    </p>
                                    <p className="col-sm-9">
                                      {UHID}
                                    </p>
                                  </div>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                                      Email ID :
                                    </p>
                                    <p className="col-sm-9">{getemail}</p>
                                  </div>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                                      DOB :
                                    </p>
                                    <p className="col-sm-9">{dob}</p>
                                  </div>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                                      Mobile :
                                    </p>
                                    <p className="col-sm-9">{creatphoneno}</p>
                                  </div>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                                      Gender :
                                    </p>
                                    <p className="col-sm-9">
                                      {creatgender == 0
                                        ? "Male"
                                        : creatgender == 1
                                          ? "Female"
                                          : creatgender == 2
                                            ? "Others"
                                            : creatgender == 3
                                              ? "Decline to State"
                                              : ""}
                                    </p>
                                  </div>
                                  {/* <div className="row">
                                  <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                                    Type :
                                  </p>
                                  <p className="col-sm-9">
                                    {type == 0 ? "Online" : "Hospital Visit"}
                                  </p>
                                </div> */}

                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                                      Branch :
                                    </p>
                                    <p className="col-sm-9">
                                      {branch}
                                    </p>
                                  </div>

                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                                      Nationality :
                                    </p>
                                    <p className="col-sm-9">
                                      {nationality}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <h5 className="card-title d-flex justify-content-between">
                                    <span>Personal Details</span>
                                    {/* <a
                                    className="edit-link"
                                    data-toggle="modal"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => onclick(e)}
                                  >
                                    <i class="bi bi-pencil-fill"></i> Edit
                                  </a> */}
                                  </h5>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">Address :</p>
                                    <p className="col-sm-9">{address.address != null ? address.address : "--"}</p>
                                  </div>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">City :</p>
                                    <p className="col-sm-9">{address.city != null ? address.city : "--"}</p>
                                  </div>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">ZipCode :</p>
                                    <p className="col-sm-9 ">{address.zipcode != null ? address.zipcode : "--"}</p>
                                  </div>
                                  <div className="row">
                                    <p className="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">Aadhaar Number:</p>
                                    <p className="col-sm-9 ">{address.aadhaar != null ? address.aadhaar : "--"}</p>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /Personal Details */}
                      </div>
                    </div>
                  </>
                ) : subtabs == "Address" ? (
                  <>

                  </>
                ) : subtabs == "Appoinment" ? (
                  <>

                  </>
                ) : subtabs == "MasterAccount" || subtabs == "SubAccount" ? (
                  <>
                    <div className="row" style={{ marginTop: 20 }}>
                      <div className="col-lg-12">
                        <div className="card">
                          <div className="card-body">
                            <SubAccount
                              loaderchange={loaderchangechild}
                              popupalert={popupalertchild}
                              popuptext={popuptextchild}
                              ismaster={ismaster}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>

                  </>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
      {popup && (
        <>
          <div className="logout_popup">
            <div class="container1">
              <div class="cookiesContent" id="cookiesPopup">
                <button
                  class="close"
                  onClick={(e) => {
                    setpopup(false);
                  }}
                >
                  ✖
                </button>
                {/* <img src={logoutimg} alt="cookies-img" /> */}
                <p style={{ marginTop: "20px" }}>
                  Do You Want to Delete the Patient Details?
                </p>
                <div style={{ display: "flex" }}>
                  <button
                    class="accept p-2 m-2"
                    onClick={(e) => confirmcancel()}
                  >
                    Yes!
                  </button>
                  <button
                    class="accept p-2 m-2"
                    onClick={(e) => setpopup(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}